module.exports = __webpack_public_path__ + "static/media/GR.ba9ab51f.png";